import { getItem } from 'common/api/winds';

import {
    FETCH_ITEM_DETAIL,
    FETCH_ITEM_DETAIL_FAILURE,
    FETCH_ITEM_DETAIL_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

import initializeForm from './initializeForm';
import resetForm from './resetForm';
import setIsNewRecord from './setIsNewRecord';
import toggleProductForm from './toggleProductForm';

export default (item) => (dispatch) => {
    dispatch(actions[FETCH_ITEM_DETAIL]());
    dispatch(resetForm());
    dispatch(toggleProductForm(true));

    getItem(item.id)
        .then(async (response) => {
            const { data } = response;

            dispatch(actions[FETCH_ITEM_DETAIL_SUCCESS](data));

            dispatch(setIsNewRecord(false));
            dispatch(
                initializeForm({
                    city: data.dp2_name.id,
                    country: data.country.id,
                    id: data.id,
                    state: data.dp1_name.id,
                    wind_speed: data.wind_speed,
                }),
            );
        })
        .catch((error) => {
            dispatch(
                actions[FETCH_ITEM_DETAIL_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            dispatch(toggleProductForm(false));
        });
};
